$(() => {
	const textboxHelper = new JJK.TextBoxHelper();
	textboxHelper.LabelInTextbox('#EmailLogin', '#EmailLoginSpan');
	textboxHelper.LabelInTextbox('#Kennwort', '#KennwortSpan');

	new JJK.Login('LoginButton');
});
